import axios from './axios';
import store from '../store';

let isSessionExpired = false;
let refreshPromise = null;
const retriedRequests = new WeakSet();

const tryRefreshToken = () => {
  if (!refreshPromise) {
    refreshPromise = store.dispatch('oidc/authenticateOidcSilent')
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

const redirectToLogin = () => {
  isSessionExpired = true;
  const redirectPath = window.location.pathname + window.location.search;
  store.dispatch('oidc/authenticateOidc', redirectPath);
};

export default () => {
  /*
    Adds token to 'Authorization' and 'Accept-language' header for authentication
  */
  axios.interceptors.request.use(async (config) => {
    // If a token refresh is in flight, wait for it before sending the request
    if (refreshPromise) {
      try {
        await refreshPromise;
      } catch (e) {
        // refresh failed; the response/redirect handler will take care of it
      }
    }

    if (isSessionExpired) {
      return Promise.reject(new Error('Session expired'));
    }

    const { lang } = store.getters.language;
    const token = store.getters['oidc/oidcAccessToken'];
    // clone the config
    const conf = { ...config };

    if (token != null) {
      conf.headers.Authorization = `Bearer ${token}`;
    }

    if (lang) {
      conf.headers.Language = lang;
    }

    return conf;
  }, (err) => Promise.reject(err));

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status !== 401 || !originalRequest) {
        return Promise.reject(error);
      }

      // If we already retried this request once, give up and send the user to login
      if (retriedRequests.has(originalRequest)) {
        redirectToLogin();
        return Promise.reject(error);
      }

      isSessionExpired = true;
      retriedRequests.add(originalRequest);

      try {
        await tryRefreshToken();
        // refresh succeeded; allow new requests to flow again and retry the original
        isSessionExpired = false;
        return await axios(originalRequest);
      } catch (refreshError) {
        redirectToLogin();
        return Promise.reject(refreshError);
      }
    },
  );
};
